<template>
  <div class="container py-4 py-xl-5">
    <div class="row">
      <div class="col-lg-8 order-2 order-lg-1">
        <div class="row no-gutters justify-content-between align-items-center">
          <h3 class="text-dark font-PB mb-0">Resultados <span v-if="conBroker">de la inmobiliaria: {{ brokerSelected
              }}</span> </h3>
          <button class="btn btn-primary btn-sm px-3 py-2 mb-0 d-block d-lg-none" type="button" data-toggle="modal"
            data-target="#modalfiltro">
            Filtros
          </button>
        </div>
        <!-- <hr> -->
        <div class="title-poster">
          <h4 class="font-SSB text-white bg-primaryDark rounded-bottom mb-4 px-4 py-2">Propiedades destacadas</h4>
        </div>


        <div class="dropdown dropshare mr-1">
          <button
            class="btn btn-primary btn-share p-0 ico-bg ico-bg-lg rounded-circle d-flex justify-content-center align-items-center"
            id="dropdownMenuOffset" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            data-offset="10,20">
            <img src="/images/icons/share.svg" alt="share">
          </button>
          <div class="dropdown-menu border-primary bg-white pt-0" aria-labelledby="dropdownMenuOffset">
            <a class="dropdown-item text-primary font-SM px-3 py-2" href="#">
              <span class="mr-2"><img src="/images/icons/share-group/link.svg" alt="link"></span>
              Copiar link</a>
            <a class="dropdown-item text-primary font-SM px-3 py-2" href="#">
              <span class="mr-2"><img src="/images/icons/share-group/mail.svg" alt="mail"></span>
              Mail</a>
            <a class="dropdown-item text-primary font-SM px-3 py-2" href="#">
              <span class="mr-2"><img src="/images/icons/share-group/whatsapp.svg" alt="whatsapp"></span>
              WhatsApp</a>
            <a class="dropdown-item text-primary font-SM px-3 py-2" href="#">
              <span class="mr-3"><img src="/images/icons/share-group/facebook.svg" alt="facebook"></span>
              Facebook</a>
          </div>
        </div>

        <div class="row px-2" v-if="featured.length > 0">
          <div class="col-md-6 col-xl-4 d-flex px-2 mb-4" v-for="property in featured">
            <a class="card w-100 hover-shadow" :href="property.url">
              <!-- <p class="btn-transactionType bg-primary text-white small position-absolute rounded font-SM px-2 py-1">
                {{ property.transactionType }}</p> -->
              <div class="btn-transactionType position-absolute d-flex">
                <p class="btn btn-primary small rounded-pill font-SM px-3 py-1 mr-2">
                  {{ property.transactionType }}</p>
                <p class="btn btn-outline-primary bg-static-white btn-sm small rounded-pill font-SM px-3 py-1 ">{{
                  property.propertyType }}</p>
              </div>
              <div class="cont-img square2">
                <img class="card-img-top" :src="property.image" alt="Card image cap">
                <button
                  class="btn btn-primary btn-share p-0 ico-bg ico-bg-lg rounded-circle  d-flex justify-content-center align-items-center">
                  <img src="/images/icons/share.svg" alt="share">
                </button>
              </div>
              <div class="row no-gutters justify-content-between align-items-center bg-primary px-3 py-2">
                <span>
                  <p class="text-white font-SM mb-0" v-if="property.price === null">A consultar</p>
                  <h4 v-if="property.price !== null">
                    {{ property.currency }} {{ formatNumber(property.price, '0,000') }}
                  </h4>
                  <p class="p-sm text-white font-AR mb-0">{{ property.neighborhood.name }}</p>
                </span>
                <div class="p-sm text-white d-flex flex-column text-center">
                  <h4 v-if="property.surface !== null" class="font-SM mb-0">{{ property.surface
                    }}<small>m<sup>2</sup></small></h4>
                  <p class="p-sm font-SM mt-n1 mb-0">Totales</p>
                  <!-- no borrar
                    <span v-if="property.rooms !== null"> / {{ property.rooms }} amb</span>  -->
                </div>
              </div>
              <div class="card-body py-3">
                <h4 class="card-title font-SSB mb-2">{{ property.title }}</h4>
                <p class="card-text p-sm lh-small font-AR text-gray mb-2"><b>{{ property.address }}</b></p>
                <p class="p-sm text-gray lh-small font-RL">Terreno en venta en Barrio Riberas, Puertos del Lago: pura
                  tranquilidad y contacto con la naturaleza y todo el confort.</p>
                <div class="d-flex pt-2">
                  <div class="text-center"><img src="/images/icons/bike.svg" alt="" class="mb-1">
                    <p class="p-sm text-primary font-AR m-0"><b>3</b> Amb.</p>
                  </div>
                  <div><img src="" alt=""></div>
                  <div><img src="" alt=""></div>
                  <div><img src="" alt=""></div>
                </div>
              </div>
              <span class="card-footer bg-transparent border-0 pt-0">
                <span class="row no-gutters justify-content-between align-items-center">
                  <!-- <p class="font-SM mb-0" v-if="property.price === null">A consultar</p>
                  <p class="font-SM mb-0"
                    v-if="property.price !== null">{{ property.currency }} {{ property.price | numeral('0,000') }}</p> -->
                  <!-- <span v-if="property.propertyType"
                        class="btn btn-outline-primary btn-sm small rounded-pill py-2">{{ property.propertyType }}</span> -->
                  <p class="card-text p-sm mb-0">Achaval cornejo</p>
                  <span class="btn btn-primary btn-sm small rounded py-2">Contactar</span>
                </span>
              </span>
            </a>
          </div>
        </div>

        <h3 class="h3-md text-dark mb-4">Propiedades
          <span class="small" v-if="form.type">{{ form.type === 'Comercial' ? 'comerciales' : 'residenciales' }}</span>
          <span class="small" v-if="form.operation">{{ form.operation === 'Venta' ? 'en venta' : 'en alquiler' }}</span>
          <span class="small" v-if="form.neighborhoods.length">{{ neighborhoodsList }}</span>
        </h3>
        <!--sin resultados-->
        <div class="col-lg-12 mb-4 mb-xl-5" v-if="paginatedItems.length === 0">
          <div class="row">
            <div class="col-md-12 card rounded-top-0 shadow overflow-hidden mx-0 py-3 mb-4">
              <div class="row no-gutters justify-content-center align-items-center bg-primary rounded">
                <div class="col-md-9 text-center py-4 py-xl-5">
                  <div class="row no-gutters justify-content-center align-items-center flex-column">
                    <p class="font-PM text-white mb-4">Tu búsqueda no ha dado resultados.</p>
                    <button type="button" @click="reset()"
                      class="btn btn-secondary btn-sm rounded-pill d-flex align-items-center rounded-pill my-0">
                      <span class="ico-trash mr-1 mt-n1"><svg aria-hidden="true" focusable="false" data-prefix="fal"
                          data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
                          class="svg-inline--fa fa-trash fa-w-14 fa-2x">
                          <path fill="currentColor"
                            d="M440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h18.9l33.2 372.3a48 48 0 0 0 47.8 43.7h232.2a48 48 0 0 0 47.8-43.7L421.1 96H440a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zm184.8 427a15.91 15.91 0 0 1-15.9 14.6H107.9A15.91 15.91 0 0 1 92 465.4L59 96h330z">
                          </path>
                        </svg></span>
                      <span>Borrar Filtros</span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--fin resultados-->
        <div class="row px-2" v-if="paginatedItems.length > 0">
          <div class="col-md-6 col-xl-4 d-flex px-2 mb-4" v-for="property in paginatedItems">


            <b-button size="sm" v-b-modal="'contactModal'" v-on:click="sendInfo(property)">
              Contactar
            </b-button>



            <a class="card w-100 hover-shadow" :href="property.url">
              <p class="btn-transactionType bg-primary text-white small position-absolute rounded font-PM px-2 py-1">
                {{ property.transactionType }}</p>
              <div class="cont-img square2">
                <img class="card-img-top" :src="property.image" alt="Card image cap">
              </div>
              <div class="card-body">
                <div class="row no-gutters justify-content-between">
                  <p class="p-sm text-primary font-AR">{{ property.neighborhood.name }}</p>
                  <p class="p-sm text-gray font-AR"><span v-if="property.surface !== null">{{ property.surface }}
                      m2</span><span v-if="property.rooms !== null"> / {{ property.rooms }} amb</span>
                  </p>
                </div>
                <h5 class="card-title font-PM mb-1">{{ property.title }}</h5>
                <p class="card-text p-sm font-AR text-gray">{{ property.address }}</p>
              </div>
              <span class="card-footer bg-transparent">
                <span class="row no-gutters justify-content-between align-items-center">
                  <p class="font-PM mb-0" v-if="property.price === null">A consultar</p>
                  <p class="font-PM mb-0" v-if="property.price !== null">{{ property.currency }} {{
                    numeral(property.price).format('0,000') }}</p>
                  <span v-if="property.propertyType" class="btn btn-outline-primary btn-sm small rounded-pill py-2">{{
                    property.propertyType }}</span>
                </span>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 order-1 order-lg-2 wrapper-filtros2">
        <h3 class="text-dark font-PB mb-0 d-none d-lg-block">
          Filtros</h3>
        <hr class="d-none d-lg-block">
        <div class="row no-gutters bg-white wrapper-content-modal modal fade px-0 px-lg-3 py-0 py-lg-4" id="modalfiltro"
          tabindex="-1" role="dialog" aria-labelledby="modalfiltroTitle" aria-hidden="true">
          <div class="modal-dialog h-100 mx-0 my-0 modal-full" role="document">
            <div class="modal-content h-100 border-0 pt-4 pt-lg-0">
              <button type="button" class="close ico-close position-absolute d-block d-lg-none" data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="modal-body d-flex flex-column px-4">
                <div class="w-100">
                  <p class="font-PM text-gray mb-2" for="place">Operación</p>
                  <div class="row no-gutters justify-content-between">
                    <div class="d-flex align-items-center w-100">
                      <div :class="{ selected: form.operation === 'Venta' }"
                        @click="form.operation = form.operation !== 'Venta' ? 'Venta' : null"
                        class="btn btn-outline-primary btn-sm mr-2 my-1 rounded w-100">
                        Venta
                      </div>
                      <div :class="{ selected: form.operation === 'Alquiler' }"
                        @click="form.operation = form.operation !== 'Alquiler' ? 'Alquiler' : null"
                        class="btn btn-outline-primary btn-sm ml-2 my-1 rounded w-100">Alquiler
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="bg-borders w-100 my-4">
                <div class="w-100">
                  <p class="font-PM text-gray mb-2" for="place">Tipo de propiedad</p>
                  <div class="row no-gutters justify-content-between">
                    <div class="d-flex align-items-center">
                      <div :class="{ selected: form.type === 'Comercial' }"
                        @click="form.type = form.type !== 'Comercial' ? 'Comercial' : null"
                        class="btn btn-outline-primary btn-sm small py-2 px-3 mr-2 my-1 rounded">Comercial
                      </div>
                      <div :class="{ selected: form.type === 'Residencial' }"
                        @click="form.type = form.type !== 'Residencial' ? 'Residencial' : null"
                        class="btn btn-outline-primary btn-sm small py-2 px-3 my-1 rounded">Residencial
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="bg-borders w-100 my-4">
                <div class="w-100">
                  <p class="font-PM text-gray mb-2" for="place">Ubicación</p>
                  <div class="w-100 mb-3">
                    <div class="content-element bg-white border border-primary rounded-pill overflow-hidden">
                      <div class="element-form-ico ico-search-blue w-100 text-primary d-flex align-items-stretch">
                        <input v-model="form.filter" type="text" @input="filter($event.target.value)"
                          class="form-control py-2 h-auto border-0 text-primary text-left" id="place" name="place"
                          placeholder="Buscar por ciudad o por barrio">
                      </div>
                    </div>
                  </div>

                  <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHanle">
                    <div class="wrapper-filtros w-100">
                      <ul class="row no-gutters pl-0">
                        <li class="col-12 col-md-12 px-2 px-md-0 pb-2 d-flex align-items-center"
                          v-for="neighborhood in filteredNeighborhoods">
                          <div class="checkbox check-left check-check w-100 pb-0 pl-2 pr-4 rounded check-filter"
                            :class="{ active: _.includes(form.neighborhoods, neighborhood.name) }">
                            <label class="d-flex align-items-center mb-0">
                              <div class="p-sm font-PM w-100 text-primary d-flex align-items-center pl-4 mb-0">
                                {{ neighborhood.name }}
                              </div>
                              <input type="checkbox" class="check" v-model="form.neighborhoods"
                                :value="neighborhood.name" hidden>
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </vue-custom-scrollbar>
                </div>

                <div class="mt-auto mt-lg-0 mb-2" v-if="hasFilters">
                  <hr class="bg-borders w-100 my-4">
                  <div class="w-100 d-flex justify-content-between align-items-center">
                    <button
                      class="btn btn-link btn-sm text-primary small py-2 px-0 my-1 hover-unlin d-flex align-items-center rounded-pill"
                      type="reset" @click="cerrarFiltro(); reset()">
                      <span class="ico-trash mr-1"><svg aria-hidden="true" focusable="false" data-prefix="fal"
                          data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
                          class="svg-inline--fa fa-trash fa-w-14 fa-2x">
                          <path fill="currentColor"
                            d="M440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h18.9l33.2 372.3a48 48 0 0 0 47.8 43.7h232.2a48 48 0 0 0 47.8-43.7L421.1 96H440a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zm184.8 427a15.91 15.91 0 0 1-15.9 14.6H107.9A15.91 15.91 0 0 1 92 465.4L59 96h330z"
                            class=""></path>
                        </svg></span>
                      <span class="mt-1">Borrar Filtros</span>
                    </button>
                    <div class="btn btn-primary btn-sm small py-2 px-4 my-1 ml-auto rounded-pill d-block d-lg-none"
                      id="closeFiltro" @click="cerrarFiltro()">Aplicar
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-pagination v-show="totalRows > perPage" @change="onPageChanged" :total-rows="totalRows" :per-page="perPage"
          v-model="currentPage" />
      </div>
    </div>


    <b-modal size="sm" id="contactModal">

      <propiedad-contacto url="/api/contacto" csrf="asdasdasd" :property="selectedProperty"></propiedad-contacto>

    </b-modal>
  </div>



</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"

export default {
  props: ['properties', 'neighborhoods', 'broker', 'featured'],
  components: {
    vueCustomScrollbar
  },
  mounted() {
    this.paginate(this.perPage, 0);

    // Filtro
    if (location.hash !== '') {

      let filtros = _.split(location.hash, "#").slice(1);


      for (var i = 0; i < filtros.length; i++) {

        let filtro = _.split(filtros[i], "=");

        if (filtro[0] == 'barrio') {
          this.form.neighborhoods = _(this.neighborhoods)
            .filter(n => n.slug === filtro[1])
            .map(n => n.name)
            .value();
        } else if (filtro[0] == 'tipo_propiedad') {
          this.form.type = filtro[1];
        }


      }


    }

    // Broker
    if (!_.isEmpty(this.broker)) {
      this.conBroker = true;
      this.brokerSelected = this.broker.name;
    }

  },
  methods: {
    filter(text) {
      let regex = new RegExp(`${text}`, 'i')
      this.filteredNeighborhoods = _.filter(this.neighborhoods, n => { return n.name.match(regex) })
    },
    cerrarFiltro() {
      $('#modalfiltro').modal('hide');
    },
    paginate(page_size, page_number) {
      let itemsToParse = this.items;
      this.paginatedItems = itemsToParse.slice(
        page_number * page_size,
        (page_number + 1) * page_size
      );
    },
    onPageChanged(page) {
      this.paginate(this.perPage, page - 1);
    },
    scrollHanle(evt) { },
    submit: function () {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.submitted = true;
      }
    },
    reset: function () {
      this.form = {
        neighborhoods: [],
        operation: null,
        type: null,
      }
      this.filteredNeighborhoods = this.neighborhoods
    },
    sendInfo(item) {
      this.selectedProperty = item
    }
  },
  provide() {
    return {
      $validator: this.$validator,
    };
  },
  watch: {
    form: {
      // This will let Vue know to look inside the array
      deep: true,
      handler: function (val, old) {
        this.items = _.filter(this.properties, p => {
          let neighborhood = this.form.neighborhoods.length === 0 || _.includes(this.form.neighborhoods, p.neighborhood.name)
          let operation = this.form.operation === null ? true : p.transactionType === this.form.operation;
          let type = this.form.type === null ? true : p.propertyType === this.form.type;
          return neighborhood && operation && type;
        })
        this.hasFilters = this.form.neighborhoods.length > 0 || this.form.operation !== null || this.form.type !== null;
        this.paginate(this.perPage, 0)
        this.totalRows = this.items.length;

        //pre-render neighborhoods text for title, if needed
        if (this.form.neighborhoods.length) {
          let ns = [...this.form.neighborhoods]
          let last = ns.pop();
          this.neighborhoodsList = 'en ' + (ns.length ? ns.join(', ') + ` y ${last}` : last);
        }
      }
    }
  },
  data() {
    return {
      filteredNeighborhoods: this.neighborhoods,
      hasFilters: false,
      items: this.properties,
      paginatedItems: this.properties,
      currentPage: 1,
      perPage: 20,
      totalRows: this.properties.length,
      submitted: false,
      form: {
        neighborhoods: [],
        operation: null,
        type: null,
      },
      neighborhoodsList: '',
      verPropiedad: false,
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false
      },
      selectedProperty: '',
      brokerSelected: '',
      conBroker: false
    };
  },
  computed: {
    rows() {
      return this.items.length
    },
    _() {
      return _;
    }
  }
}
</script>

<style lang="scss">
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 400px;
}

#modalfiltro {
  z-index: 100;
}

#contactModal {
  display: block;
  width: 50%;
  margin-left: 19%;

}
</style>
